/**
 * @generated SignedSource<<024b1b4dc5ba7e7f15a42edabe3a95b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
export type BrandMessageTemplateCreateInput = {
  additionalContent?: string | null;
  adult: boolean;
  buttons?: ReadonlyArray<BrandMessageButtonInput> | null;
  carousel?: BrandMessageCarouselInput | null;
  chatBubbleType: ChatBubbleTypeEnum;
  commerce?: BrandMessageCommerceInput | null;
  content?: string | null;
  coupon?: BrandMessageCouponInput | null;
  header?: string | null;
  image?: Upload | null;
  imageLink?: string | null;
  imageUrl?: string | null;
  mainWideItem?: BrandMessageWideItemInput | null;
  subWideItemList?: ReadonlyArray<BrandMessageWideItemInput> | null;
  templateName: string;
  video?: Upload | null;
  videoId?: string | null;
};
export type BrandMessageButtonInput = {
  bizFormId?: string | null;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
  linkType: string;
  name: string;
  ordering?: number | null;
};
export type BrandMessageCarouselInput = {
  head?: BrandMessageCarouselHeadInput | null;
  list: ReadonlyArray<BrandMessageCarouselItemInput>;
  tail?: BrandMessageLinkInput | null;
};
export type BrandMessageCarouselHeadInput = {
  content?: string | null;
  header?: string | null;
  image?: Upload | null;
  imageUrl?: string | null;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type BrandMessageCarouselItemInput = {
  additionalContent?: string | null;
  buttons?: ReadonlyArray<BrandMessageButtonInput> | null;
  commerce?: BrandMessageCommerceInput | null;
  content?: string | null;
  coupon?: BrandMessageCouponInput | null;
  header?: string | null;
  image?: Upload | null;
  imageLink?: string | null;
  imageUrl?: string | null;
};
export type BrandMessageCommerceInput = {
  discountFixed?: number | null;
  discountPrice?: number | null;
  discountRate?: number | null;
  regularPrice?: number | null;
  title: string;
  usePriceVariable: boolean;
};
export type BrandMessageCouponInput = {
  description: string;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
  title: string;
};
export type BrandMessageLinkInput = {
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
};
export type BrandMessageWideItemInput = {
  image?: Upload | null;
  imageUrl?: string | null;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
  title: string;
};
export type BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation$variables = {
  input: BrandMessageTemplateCreateInput;
};
export type BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation$data = {
  readonly brandMessageTemplateCreate: {
    readonly id: string;
  };
};
export type BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation = {
  response: BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation$data;
  variables: BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandMessageTemplate",
    "kind": "LinkedField",
    "name": "brandMessageTemplateCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "53a7b6d97306aecd5cb1ed02349f509b",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandMessageTemplateCreateDialog_brandMessageTemplateCreateMutation(\n  $input: BrandMessageTemplateCreateInput!\n) {\n  brandMessageTemplateCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffb1bc9a20bcf0575d6dfa7d754b8f0a";

export default node;
